import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useSearchParams } from 'react-router-dom';
import PreinscriptionVote from '../components/PreinscriptionVote';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter 459 — 📊 Vote en 1 clic depuis l'e-mail (lien personnel) ; réutilisé dans l'Espace Adhérent.
export function SondageVote({ sondage, token, onVoted, compact = false, choixInitial = '' }) {
  // Iter 656 — avant-première / pré-inscription : fiche voyage dédiée
  if (sondage.type === 'preinscription') return <PreinscriptionVote sondage={sondage} token={token} onVoted={onVoted} compact={compact} choixInitial={choixInitial} />;
  return <SondageClassique sondage={sondage} token={token} onVoted={onVoted} compact={compact} />;
}

function SondageClassique({ sondage, token, onVoted, compact = false }) {
  const [ouvert, setOuvert] = useState(!compact);
  const [choix, setChoix] = useState(sondage.mon_vote || []);
  const [ok, setOk] = useState(!!sondage.vote_at);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(sondage.resultats ? { resultats: sondage.resultats, nb: sondage.nb_votants } : null);
  const voter = async (liste) => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/sondage/${sondage.id}/${token}/voter`, { choix: liste });
      setChoix(liste); setOk(true); onVoted && onVoted(liste);
      if (r.data.resultats) setRes({ resultats: r.data.resultats, nb: r.data.nb_votants });
    } catch (e) { alert(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <div className={`bg-white border-2 border-[#1E3A5F]/20 rounded-2xl ${compact ? 'p-3' : 'p-4'} space-y-2`} data-testid={`sondage-vote-${sondage.id}`}>
      {compact ? (
        <button type="button" onClick={() => setOuvert(o => !o)} className="w-full flex items-center justify-between gap-2 text-left" data-testid={`sondage-toggle-${sondage.id}`}>
          <span className="text-sm font-bold text-[#1E3A5F] leading-snug">📊 {sondage.question}</span>
          <span className="flex items-center gap-1.5 shrink-0">
            {ok ? <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700">✅ répondu</span>
              : !sondage.clos && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-100 text-red-700">à répondre</span>}
            <span className="text-[#1E3A5F]">{ouvert ? '▴' : '▾'}</span>
          </span>
        </button>
      ) : <p className="font-bold text-[#1E3A5F]">📊 {sondage.question}</p>}
      {ouvert && <>
      {sondage.description && <p className="text-xs text-gray-600 whitespace-pre-line">{sondage.description}</p>}
      {sondage.clos ? <p className="text-xs text-gray-500 italic">Sondage clos — merci.</p> : (
        <div className="space-y-1.5">
          {sondage.options.map(o => {
            const sel = choix.includes(o.id);
            return (
              <button key={o.id} disabled={busy} data-testid={`sondage-choix-${o.id}`}
                onClick={() => sondage.multi ? setChoix(c => sel ? c.filter(x => x !== o.id) : [...c, o.id]) : voter([o.id])}
                className={`w-full text-left px-3 py-2 rounded-lg border text-sm font-bold transition ${sel ? 'bg-[#1E3A5F] text-white border-[#1E3A5F]' : 'bg-white hover:bg-sky-50 border-gray-300'}`}>
                {sel ? '✅ ' : ''}{o.label}
              </button>
            );
          })}
          {sondage.multi && <button onClick={() => voter(choix)} disabled={busy || !choix.length} className="px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm font-bold disabled:opacity-40" data-testid="sondage-valider">Valider mes réponses</button>}
        </div>
      )}
      {ok && <p className="text-xs text-emerald-700 font-bold" data-testid="sondage-merci">✅ Réponse enregistrée — merci ! Vous pouvez la modifier tant que le sondage est ouvert.</p>}
      {res && (
        <div className="bg-sky-50 border border-sky-200 rounded-xl p-3 space-y-1.5" data-testid="sondage-resultats-live">
          <p className="text-xs font-bold text-[#1E3A5F]">📈 Résultats en direct — {res.nb} réponse{res.nb > 1 ? 's' : ''}</p>
          {res.resultats.map(o => {
            const pct = res.nb ? Math.round(100 * o.votes / res.nb) : 0;
            return (
              <div key={o.id} className="text-xs" data-testid={`sondage-live-${o.id}`}>
                <div className="flex justify-between"><span className={choix.includes(o.id) ? 'font-bold' : ''}>{choix.includes(o.id) ? '✅ ' : ''}{o.label}</span><strong>{pct} %</strong></div>
                <div className="h-2 bg-white rounded border border-sky-100"><div className="h-full bg-[#1E3A5F] rounded transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
              </div>
            );
          })}
        </div>
      )}
      {sondage.date_limite && <p className="text-[11px] text-gray-500">Réponse souhaitée avant le {sondage.date_limite}.</p>}
      </>}
    </div>
  );
}

export default function SondagePage() {
  const { sid, token } = useParams();
  const [params] = useSearchParams();
  const [s, setS] = useState(null);
  const [err, setErr] = useState('');
  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/sondage/${sid}/${token}`);
      const pre = params.get('choix');
      // 'positionne' (avant-première) ouvre le formulaire nb de personnes au lieu de voter directement
      if (pre && pre !== 'positionne' && !r.data.vote_at && !r.data.clos && r.data.options.some(o => o.id === pre)) {
        await axios.post(`${API}/sondage/${sid}/${token}/voter`, { choix: [pre] });
        r.data.mon_vote = [pre]; r.data.vote_at = new Date().toISOString();
      }
      setS(r.data);
    } catch (e) { setErr(e.response?.data?.detail || 'Lien invalide'); }
  }, [sid, token, params]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-50 to-white p-4 flex items-start justify-center">
      <div className={`w-full ${s?.type === 'preinscription' ? 'max-w-xl' : 'max-w-md'} mt-8 space-y-3`}>
        <p className="text-center text-xs font-bold text-[#1E3A5F] uppercase tracking-wide">Rhône Alpes Amitié Voyages</p>
        {err && <p className="text-center text-red-600 font-bold" data-testid="sondage-erreur">{err}</p>}
        {s && <SondageVote sondage={s} token={token} choixInitial={params.get('choix') || ''} />}
        <p className="text-center text-xs"><a href="/espace-adherent" className="text-sky-700 underline">Mon Espace Adhérent</a></p>
      </div>
    </div>
  );
}
